import React from 'react';
import { Layout } from 'antd';
import styles from './PageContent.module.less';
import { IPageContent } from './PageContent.type';
const { Content } = Layout;

export const PageContent = ({ children }: IPageContent) => {
  return <Content className={`${styles.PageContent}`}>{children}</Content>;
};
